import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19708085"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["points", "strokeWidth"]

import gsap from 'gsap'
import { computed, onMounted, onUnmounted, PropType, ref, nextTick, watch } from 'vue';
import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager';
import lottie, { AnimationItem } from 'lottie-web'
import FrontResources from '@/core/FrontResources';


enum IconVariation {
  Primary = 'primary',
  Secondary = 'secondary'
}

enum IconColor {
  Light = 'light',
  Dark = 'dark',
  DarkRed = 'dark-red'
}

enum IconBorder {
  TL = "top-left",
  BR = "bottom-right",
  BL = "bottom-left",
}

const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    required: true
  },
  variant: {
    type: String as PropType<IconVariation>,
    default: IconVariation.Primary
  },
  color: {
    type: String as PropType<IconColor>,
    default: IconColor.Light
  },
  strokeWidth: {
    type: Number,
    default: 1
  },
  borderPosition: {
    type: String as PropType<IconBorder>,
    default: IconBorder.BR
  },
  borderWidth: {
    type: Number,
    default: 16
  },
  isAnimationBlocked: {
    type: Boolean,
    default: false
  },
  isLottie: {
    type: Boolean,
    default: false
  }
},
  setup(__props, { expose }) {

const props = __props



const el = ref(null)
const shapeOpt = ref({ topLeftRatio: 0, bottomRightRatio: 0, bottomLeftRatio: 0, topRightRatio: 0 })
const backgroundData = ref({ viewBox: { minX: 0, minY: 0, width: 0, height: 0 }, polygon: { points: "" } })
const isIconHovered = ref(false)
const timeoutResetId = ref(0)

const anim = ref(null)
const animationItem = ref<AnimationItem>(null)

const play = () => {
  animationItem?.value?.play()
}

const pause = () => {
  animationItem?.value?.pause()
}

expose({
  play,
  pause
})

const elClass = computed(() => {
  return ['btn', `btn--${props.variant}`, `btn--${props.color}`]
})

const getShape = ({ topLeftRatio = 0, topRightRatio = 0, bottomRightRatio = 0, bottomLeftRatio = 0 }) => {
  const elBCR = el.value.getBoundingClientRect()
  return `
      ${props.strokeWidth + (props.borderWidth * topLeftRatio)} ${props.strokeWidth},
      ${elBCR.width - props.strokeWidth - (props.borderWidth * topRightRatio)} ${props.strokeWidth},
      ${elBCR.width - props.strokeWidth} ${props.strokeWidth + (props.borderWidth * topRightRatio)},
      ${elBCR.width - props.strokeWidth} ${elBCR.height - props.strokeWidth * 2 - (props.borderWidth * bottomRightRatio)},
      ${elBCR.width - props.strokeWidth - (props.borderWidth * bottomRightRatio)} ${elBCR.height - props.strokeWidth * 2},
      ${(props.borderWidth * bottomLeftRatio) + props.strokeWidth} ${elBCR.height - props.strokeWidth * 2},
      ${props.strokeWidth} ${elBCR.height - props.strokeWidth * 2 - (props.borderWidth * bottomLeftRatio)},
      ${props.strokeWidth} ${props.strokeWidth + (props.borderWidth * topLeftRatio)} `
}

onMounted(() => {
  if (props.isLottie) {
    animationItem.value = lottie.loadAnimation({
      container: anim.value as Element,
      renderer: 'svg',
      autoplay: true,
      loop: true,
      animationData: FrontResources.Group.get(`${props.name}`),
      // animationData: require(`@/assets/lottie/${props.name}.json`),
    })
  }

  window.addEventListener('resize', resize)
  resize()
})

// onBeforeUnmount(() => {
//   console.log( isIconHovered.value);
// })

onUnmounted(() => {
  animationItem?.value?.destroy()
  window.removeEventListener('resize', resize)
})

const onClick = () => {
  if(props.variant === IconVariation.Secondary) {
    AudioManager.play(AUDIO_ID.UI_CLICK_Secondary)
  } else {
    AudioManager.play(AUDIO_ID.UI_CLICK_Main)
  }
}

const handelMouseEnter = () => {
  isIconHovered.value = true

  let opt = {...shapeOpt.value}
  switch (props.borderPosition) {
    case IconBorder.BR:
      opt = {...opt, bottomRightRatio: 0, topLeftRatio: 1}
      break;
    case IconBorder.TL:
      opt = {...opt, bottomRightRatio: 1, topLeftRatio: 0}
      break;
    case IconBorder.BL:
      opt = {...opt, bottomLeftRatio: 0, topRightRatio: 1}
      break;
    // case IconBorder.TR:
    //   opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0}
    //   break;
    default:
      break;
  }

  gsap.to(shapeOpt.value, {
    ...opt,
    duration: 0.35,
    ease: 'power2.inOut'
  })

  AudioManager.play(AUDIO_ID.UI_HOVER)
}

const handleMouseLeave = () => {
  isIconHovered.value = false

  if(props.isAnimationBlocked)
    return

  let opt = {...shapeOpt.value}
  switch (props.borderPosition) {
    case IconBorder.BR:
      opt = {...opt, bottomRightRatio: 1, topLeftRatio: 0}
      break;
    case IconBorder.TL:
      opt = {...opt, bottomRightRatio: 0, topLeftRatio: 1}
      break;
    case IconBorder.BL:
      opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0}
      break;
    // case IconBorder.TR:
    //   opt = {...opt, bottomLeftRatio: 1, topRightRatio: 0}
    //   break;
    default:
      break;
  }
    gsap.to(shapeOpt.value, {
      ...opt,
      duration: 0.35,
      ease: 'power2.inOut'
    })
}

watch(() => props.isAnimationBlocked, (val) => {
  if(!val) {
    //TODO Replace by hover state on about cross Icon when leave
    timeoutResetId.value = setTimeout(() => {
      if(!isIconHovered.value)
        handleMouseLeave()
    }, 300);
  }
})

watch(isIconHovered, (val) => {
  if(val && timeoutResetId.value) {
    clearTimeout(timeoutResetId.value)
  }
})

watch(() => shapeOpt, (val) => {
  backgroundData.value = {
    ...backgroundData.value,
    polygon: { points: getShape(val.value) }
  }
}, {deep: true})

const resize = async () => {
  await nextTick()
  const elBCR = el.value.getBoundingClientRect()
  let points = ""
  if (props.borderPosition === IconBorder.BR) {
    shapeOpt.value = {...shapeOpt.value, bottomRightRatio: 1}
  } else if (props.borderPosition === IconBorder.TL) {
    shapeOpt.value = {...shapeOpt.value, topLeftRatio: 1}
  } else if (props.borderPosition === IconBorder.BL) {
    shapeOpt.value = {...shapeOpt.value, bottomLeftRatio: 1}
  }
  backgroundData.value = {
    viewBox: {
      minX: 0,
      minY: 0,
      width: elBCR.width,
      height: elBCR.height
    },
    polygon: {
      points
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("button", {
    onMouseleave: handleMouseLeave,
    onMouseenter: handelMouseEnter,
    onClick: onClick,
    ref_key: "el",
    ref: el,
    class: _normalizeClass(_unref(elClass))
  }, [
    _createElementVNode("span", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: `${backgroundData.value.viewBox.minX} ${backgroundData.value.viewBox.minY} ${backgroundData.value.viewBox.width} ${backgroundData.value.viewBox.height}`,
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("polygon", {
          points: backgroundData.value.polygon.points,
          fill: "none",
          strokeWidth: __props.strokeWidth
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2))
    ]),
    _renderSlot(_ctx.$slots, "default"),
    (!__props.isLottie)
      ? (_openBlock(), _createBlock(_component_ui_icon, {
          key: 0,
          class: "icon",
          name: __props.name
        }, null, 8, ["name"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "anim",
          ref_key: "anim",
          ref: anim
        }, null, 512))
  ], 34))
}
}

})